import { matchPath } from 'react-router';

// Values are `--gz-*` token family names, so a consumer knows which palette to pull from.
export const SECTION_COLOR = ['marine', 'amethyst', 'bluebell', 'sage'] as const;
export type SectionColor = typeof SECTION_COLOR[number];

export const DEFAULT_SECTION_COLOR: SectionColor = 'marine';

// Most specific first. Each section needs a bare and a splat pattern, since react-router's
// `/journeys/*` does not match `/journeys` itself.
const COLOR_BY_ROUTE: ReadonlyArray<{ pattern: string; color: SectionColor }> = [
    { pattern: '/careers/:occupationId/*', color: 'amethyst' },
    { pattern: '/careers/:occupationId', color: 'amethyst' },
    { pattern: '/journeys/*', color: 'bluebell' },
    { pattern: '/journeys', color: 'bluebell' },
    { pattern: '/skills/*', color: 'sage' },
    { pattern: '/skills', color: 'sage' },
];

// Pure so it can be read outside a router. Inside one, prefer `useSectionColor`.
export const getSectionColor = (pathname: string): SectionColor => {
    for (const { pattern, color } of COLOR_BY_ROUTE) {
        if (matchPath(pattern, pathname)) {
            return color;
        }
    }
    return DEFAULT_SECTION_COLOR;
};
